import { render, staticRenderFns } from "./fade-twin.vue?vue&type=template&id=2833d1d4&lang=pug&"
import script from "./fade-twin.vue?vue&type=script&lang=ts&"
export * from "./fade-twin.vue?vue&type=script&lang=ts&"
import style0 from "./fade-twin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports